import * as React from "react";
import { Application } from "@ova-studio/react-hyper-admin";
import { ModulesRegistry } from "./helpers/ModulesRegistry";
import Logo from "./assets/Logo";
import Auth from "./core/Auth";
import './init';
import searchTypes from "./core/searchTypes";
import { MediaLibrary } from "@ova-studio/react-media-library";
const adminDomain = window.location.hostname;
const siteDomain = adminDomain.replace('admin.', '');
const appConfig = {
    base: {
        appName: 'OVA Engine',
        appCreateYear: 2021,
        logoComponent: Logo,
        siteDomain: siteDomain,
    },
    actions: {
        endpoint: 'actions',
    },
    search: {
        endpoint: 'search',
        types: searchTypes,
    },
    auth: {
        loginHandler: Auth.login,
        authUserResolver: Auth.getAuth,
        logoutHandler: Auth.logout,
    },
    navigation: {
        navigationMenuResolver: () => ModulesRegistry.getNavigation(),
        globalButtonsResolver: () => ModulesRegistry.getGlobalButtons(),
        navigationCountersResolver: () => ModulesRegistry.getNavCounters(),
    },
    external: {
        rtc: {
            rtcWsUrl: `wss://${adminDomain}/rtc/ws/`,
            baseEndpoint: 'collaboration',
        },
        media: {
            endpoint: 'media',
        },
        websocket: {
            host: adminDomain,
            port: '443',
            appKey: 'ws-admin',
            authEndpoint: '/api/broadcasting/auth',
        }
    }
};
const onAppReady = (app) => {
    ModulesRegistry.initModules(app);
    MediaLibrary.initializer(app);
};
const OvaEngineAdmin = ({ config: instanceConfig, editorConfig }) => {
    const config = React.useMemo(() => (Object.assign(Object.assign(Object.assign({}, appConfig), (instanceConfig ? {
        base: Object.assign(Object.assign({}, appConfig.base), instanceConfig),
    } : {})), (editorConfig ? {
        external: Object.assign(Object.assign({}, appConfig.external), { editor: editorConfig }),
    } : {}))), []);
    const appRoutes = React.useMemo(() => ModulesRegistry.getRoutes(), []);
    return (React.createElement(Application, { appRoutes: appRoutes, config: config, onAppReady: onAppReady }));
};
export default OvaEngineAdmin;
//# sourceMappingURL=OvaEngineAdmin.js.map